(() => {
  angular
    .module('app')
    .controller(
      'finance.views.saleTransactions.makePaymentPending.page',
      MakePaymentPendingontroller
    );

  MakePaymentPendingontroller.$inject = [];

  function MakePaymentPendingontroller() {
    // No dependencies and logic for this controller.
  }
})();
